import { useReadContracts } from 'wagmi';
import { erc20Abi, uniswapV2FactoryAbi, uniswapV2PairAbi } from '@syntra/abi';
import { DEPLOYMENT as D } from '../config/env.ts';

const ZERO = '0x0000000000000000000000000000000000000000';

/** SYN/USDT pool state (reserves oriented as SYN, USDT) and whether BNB can be routed. */
export function usePool() {
  const q = useReadContracts({
    allowFailure: true,
    query: { refetchInterval: 10_000 },
    contracts: [
      { address: D.syntraUsdtPair, abi: uniswapV2PairAbi, functionName: 'getReserves' },
      { address: D.syntraUsdtPair, abi: uniswapV2PairAbi, functionName: 'token0' },
      { address: D.syntraUsdtPair, abi: erc20Abi, functionName: 'totalSupply' },
      { address: D.factory, abi: uniswapV2FactoryAbi, functionName: 'getPair', args: [D.wbnb, D.usdt] },
    ],
  });
  const r = q.data;
  const reserves = r?.[0]?.status === 'success' ? (r[0].result as readonly [bigint, bigint, number]) : undefined;
  const t0 = r?.[1]?.status === 'success' ? (r[1].result as string) : undefined;
  const syntraFirst = t0?.toLowerCase() === D.syntra.toLowerCase();
  return {
    rSyntra: reserves ? (syntraFirst ? reserves[0] : reserves[1]) : undefined,
    rUsdt: reserves ? (syntraFirst ? reserves[1] : reserves[0]) : undefined,
    supply: r?.[2]?.status === 'success' ? (r[2].result as bigint) : undefined,
    bnbRoutable: r?.[3]?.status === 'success' ? (r[3].result as string) !== ZERO : false,
    refetch: q.refetch,
  };
}
